import React, { useState, useEffect } from "react";
import { FetchAllHomepage, getplanHomepage } from "../redux/actions/PlanAction";
import { useDispatch, useSelector } from "react-redux";
import "rc-tooltip/assets/bootstrap.css";
import "rc-slider/assets/index.css";
import { Link } from "react-router-dom";
// import rzpsvg from "../assets/plans/razorpay-logo.5cdb58df 1.svg";
// import stripesvg from "../assets/plans/Group.svg";
import { initGA, initPixel } from "../helpers/CampaignEvents";
import Loder from "../components/loder";
import { currencyConverter } from "../helpers/planPrice";
 
function HomepagePlans() {
  const dispatch = useDispatch();
  const [content, setContent] = useState();
  const [duration, setDuration] = useState("15min");
  const [day, setDay] = useState(1);
  const [month, setMonth] = useState(6);
  const [discount, setDiscount] = useState(15);
  const [planDetails, setPlanDetails] = useState();
  const [usdPrice, setUSDprice] = useState(0);
  const [gstAmount, setGstAmount] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [grandTotal, setGrandTotal] = useState("");

  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  const currency = JSON.parse(localStorage.getItem("CURRENCY"));

  useEffect(() => {
    initPixel();
    initGA();
    const onSuccess = (data) => {
      setContent(data);
    };
    dispatch(getplanHomepage(onSuccess));
    dispatch(FetchAllHomepage());
    setUSDprice(currency ? currency : 0);
  }, []);

  const Plans = useSelector((state) => state.PlanReducer.plans);

  useEffect(() => {
    if (Plans) {
      Plans.map((data, i) => {
        if (
          data.classDuration === duration &&
          data.frequency === parseInt(day)
        ) {
          setPlanDetails(data);
        }
      });
    }
  }, [Plans]);

  useEffect(() => {
    Plans.map((data, i) => {
      if (data.classDuration === duration && data.frequency === parseInt(day)) {
        setPlanDetails(data);
      }
    });
  }, [duration, day]);

  useEffect(() => {
    if (planDetails) {
      var total;
      var discountPrice = Math.round(
        ((planDetails.originalPrice * month) / 100) * discount
      );

      setDiscountAmount(discountPrice);

      //total amount
      total = Math.round(planDetails.originalPrice * month - discountPrice);
      //gst amount
      var gstamount = Math.round((total / 100) * 18);
      setGstAmount(gstamount);
      if (time_zone.country === "IN") {
        total = total + gstamount;
      } else {
        total = Math.round((total / usdPrice).toFixed(2) * 100);
      }

      setGrandTotal(total);
    }
  }, [month, planDetails]);

  return (
    <div className="homepage_plan ">
      {/* <div className="list-board">
        <div className="container">
        <p>PLANS & PRICING</p>
        <h1>Simple, all inclusive pricing.</h1>
        <p>Check out our comprehensive and flexible plans to unlock the endless possibilities for you.</p>
      </div>
      </div> */}

      <div className="container">
        <div className="card mx-auto">
          <div className="d-md-flex">
            <div className="plan-details">
              <div className="duration">
                <h6>Select Duration</h6>
                <div className="d-md-flex p-2">
                  {content ? (
                    <>
                      <div className="dropdown m-1">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownMinute"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {duration} per session
                        </button>

                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMinute"
                        >
                          {content.durations.map((data, i) => (
                            <span
                              className="dropdown-item"
                              key={i}
                              onClick={() => setDuration(data)}
                            >
                              {data} per session
                            </span>
                          ))}
                        </div>
                      </div>

                      <div className="dropdown m-1">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="dropdownWeek"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          {day} day per week
                        </button>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownWeek"
                        >
                          {content.frequencies.map((data, i) => (
                            <span
                              className="dropdown-item"
                              key={i}
                              onClick={() => setDay(data)}
                            >
                              {data} day per week
                            </span>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <div className="text-center mx-auto m-5">
                      <Loder />
                    </div>
                  )}
                </div>
              </div>

              <div className="target mt-2 p-2 mt-md-4">
                <h6>Select Target</h6>

                {content ? (
                  content.months.sort((x,y) => {return y.no - x.no}).map((data, i) => (
                    <div key={i}>
                      <input
                        type="radio"
                        id={data.no + "plan"}
                        value={data.no}
                        onChange={(e) => {
                          setMonth(Number(e.target.value));
                          setDiscount(data.discount);
                        }}
                        name="radio-group"
                      />
                      <label
                        className={`price-card mt-3 ${
                          month === data.no ? "active-price-card " : ""
                        }`}
                        htmlFor={data.no + "plan"}
                      >
                        <div className="d-flex justify-content-between price-card-body">
                          <div>
                            <h4>{data.no} Month</h4>
                            <p>
                              No. of sessions:{" "}
                              <strong>{data.no * day * 4}</strong>
                            </p>
                          </div>
                          <h3 className="price my-auto">
                            <strong>
                              {planDetails
                                ? time_zone.country === "IN"
                                  ? "₹ " +
                                    Math.round(
                                      planDetails.originalPrice -
                                        (planDetails.originalPrice / 100) *
                                          data.discount
                                    )
                                  : currencyConverter(
                                      Math.round(
                                        planDetails.originalPrice -
                                          (planDetails.originalPrice / 100) *
                                            data.discount
                                      ) / usdPrice
                                    )
                                : 0}
                            </strong>
                            /mth.
                          </h3>
                        </div>
                        {
                          data.no === 6 || data.no === 12?
                          <span className="badge">MOST SELECTED</span>
                          :""
                        }
                        <span className="label">SAVE {data.discount}%</span>
                      </label>
                    </div>
                  ))
                ) : (
                  <div className="text-center m-5">
                    <Loder />
                  </div>
                )}
              </div>
            </div>
            <div className="billing">
              <h6>BILL SUMMARY</h6>
              <div className="summery mt-4">
                <div className="d-flex justify-content-between">
                  <p>Sub-Total :</p>
                  <p>
                    {time_zone.country === "IN"
                      ? "₹" +
                        new Intl.NumberFormat().format(
                          Math.round(planDetails?.originalPrice * month)
                        )
                      : currencyConverter(
                          Math.round(planDetails?.originalPrice * month) /
                            usdPrice
                        )}
                  </p>
                </div>
                {time_zone.country === "IN" ? (
                  <div className="d-flex justify-content-between">
                    <p>GST Charges(18%) :</p>
                    <p> ₹ {new Intl.NumberFormat().format(gstAmount)}</p>
                  </div>
                ) : (
                  ""
                )}

                <div className="d-flex justify-content-between">
                  <p className="discount">Discount({discount + "%"}):</p>
                  <p className="discount">
                    {" "}
                    {time_zone.country === "IN"
                      ? "-₹" + new Intl.NumberFormat().format(discountAmount)
                      : currencyConverter(discountAmount / usdPrice)}
                  </p>
                </div>

                <hr />
                <div className="d-flex justify-content-between grand-total">
                  <p className="grand-total">Grand Total :</p>
                  <p>
                    {time_zone.country === "IN"
                      ? "₹" + new Intl.NumberFormat().format(grandTotal)
                      : currencyConverter(grandTotal / 100)}
                  </p>
                </div>
              </div>

              <div className="make-payment mt-3">
                <div className="d-flex justify-content-center mt-3">
                  <Link to="/login" className="payment_btn mx-auto mt-2">
                    Proceed to Payment
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomepagePlans;
